/* eslint-disable sonarjs/cognitive-complexity */
import {
  BaSeButton,
  BaSeContainer,
  BaSeDialogContext,
  BaSeGrid,
  BaSeGridItem,
  BaSeHeading6,
  BaSeInput,
  BaSeParagraph,
  BaSeSmall1,
  BaSeTabs,
  BaSeTheme,
} from '@base/react';
import React from 'react';
import { useMessage } from '../../../../hooks/messages/useMessage';
import { useModule } from '../../../../hooks/module/module';
import { useInterviewService } from '../../../../hooks/services/interview-service';
import { wordCounter } from '../../../../utils/counterWords/counter';
import AnswersCandidateDetail from './components/answers-candidate-detail';
import { SeeAnswersNotesContext } from './context/see-answers-notes-context';
import FormJustificativa from './form-justificatifa';

import ConfirmManualEvalate from './dialogs/confirm-manual-evaluate';
import {
  BoxNota,
  BoxPendingAvaliation,
  BoxPendingAvaliationButtons,
  Container,
  ContainerDialog,
  ContainerNotes,
  ContainerResultnOTES,
  ContainerTitle,
  Content,
  ContentBlocs,
  ContentNotes,
  ContentRow,
  ContentTabs,
  ContentTitle,
  InputDisabled,
  Item,
  Wrapper,
} from './notasRespostas-styled';

function VisualizarNotasRespostas({ setShowNotas, codigo, fetchData }) {
  const { respostas, notasRespostas, interview } = React.useContext(
    SeeAnswersNotesContext,
  );

  const { moduleSelected } = useModule();

  const { showModal } = React.useContext(BaSeDialogContext);
  const { pendingInterview } = useInterviewService();
  const { handleError, handleAttention, handleSuccess } = useMessage();

  const [disabledIndex, setDisabledIndex] = React.useState(false);
  const [onTabIndex, setOnTabIndex] = React.useState(0);
  const [id, setId] = React.useState();
  const [status, setStatus] = React.useState();
  const [statusInterview, setStatusInterview] = React.useState('');

  const [saveManualEvaluate, setSaveManualEvaluate] = React.useState(false);
  const [scoreItems, setScoreItems] = React.useState([]);
  const [justification, setJustification] = React.useState('');

  const handleCancel = React.useCallback(() => {
    setShowNotas((prev) => !prev);
    setOnTabIndex(0);
    fetchData({
      page: 0,
      sort: { type: 'DESC' },
    });
  }, [fetchData, setShowNotas]);

  const handleAprove = React.useCallback(async () => {
    const dto = {
      idInterview: id,
      option: 'APROVADO',
    };
    try {
      await pendingInterview(dto);
      await setShowNotas((prev) => !prev);
      handleSuccess('Operação realizada com sucesso!');
    } catch (error) {
      handleError('Erro ao tentar aprovar entrevista!');
    }
  }, [handleError, id, handleSuccess, setShowNotas, pendingInterview]);

  const openDialogConfirmAprove = React.useCallback(() => {
    return showModal({
      actions: [
        {
          action: 'Não',
          type: 'primary',
          color: BaSeTheme.colors.institucionais.cinzaSebrae10,
        },
        {
          action: 'Aprovar',
          type: 'secondary',
        },
      ],
      size: 'medium',
      title: 'Confirmar aprovação',
      dismissible: true,
      dismissibleIconColor: BaSeTheme.colors.defaultColors.black,
      dismissibleIconType: 'tertiary',
      content: ({ closeModal, emitEvent }) => (
        <ContainerDialog>
          <BaSeHeading6
            color={BaSeTheme.colors.feedbackInterface.atencao55}
            isBold={true}
          >
            Atenção!
          </BaSeHeading6>
          <BaSeParagraph>
            Tem certeza que deseja aprovar a entrevista desse candidato?
          </BaSeParagraph>
        </ContainerDialog>
      ),
      onChooseAction: (action) => {
        if (action === 'Aprovar') {
          handleAprove();
        }
      },
    });
  }, [showModal, handleAprove]);

  const openDialogRequestAprove = React.useCallback(() => {
    return showModal({
      actions: [],
      size: 'medium',
      title: 'Solicitar revisão',
      dismissible: true,
      dismissibleIconColor: BaSeTheme.colors.defaultColors.black,
      dismissibleIconType: 'tertiary',
      content: ({ closeModal, emitEvent }) => (
        <FormJustificativa
          id={id}
          closeModal={closeModal}
          setShowNotas={setShowNotas}
        />
      ),
      onChooseAction: (action) => {
        if (action === 'Solicitar revisão') {
        }
      },
    });
  }, [showModal, id, setShowNotas]);

  const setAnswers = React.useCallback(
    (question = '') => {
      const resp = respostas.filter((r) => r.question.id === question);
      return resp[0];
    },
    [respostas],
  );

  const handleChangeManualEvaluate = (descProfileItem, newValue) => {
    setScoreItems((prevItems) =>
      prevItems.map((item) =>
        item.descProfileItem === descProfileItem
          ? { ...item, scoreManualEvaluation: newValue }
          : item,
      ),
    );
  };
  React.useEffect(() => {
    if (notasRespostas.scoreItems) {
      const response = notasRespostas.scoreItems.map((item) => ({
        ...item,
        scoreManualEvaluation: item.scoreManualEvaluation ?? '',
      }));
      setScoreItems(response);
    }

    if (notasRespostas.justification) {
      setJustification(notasRespostas.justification);
    }
  }, [notasRespostas.justification, notasRespostas.scoreItems]);

  const returnTotal = React.useCallback(() => {
    return scoreItems.reduce(
      (total, item) => total + Number(item.scoreManualEvaluation),
      0,
    );
  }, [scoreItems]);

  const openDialogConfirmEvaluate = React.useCallback(
    (value) => {
      return showModal({
        actions: [],
        alignActions: 'left',
        size: 'small',
        title: `${'Confirmar nota editada'}`,
        dismissibleIconColor: BaSeTheme.colors.defaultColors.black,
        dismissibleIconType: 'tertiary',
        content: ({ closeModal, emitEvent }) => (
          <>
            <ConfirmManualEvalate
              handleCancel={handleCancel}
              statusInterview={statusInterview}
              closeModal={closeModal}
              emitEvent={emitEvent}
              manualEvaluationData={scoreItems}
              id={id}
              justificationDefault={justification}
              setJustificationDefault={setJustification}
              totalManualEvaluate={returnTotal}
            />
          </>
        ),
        onChooseAction: (action) => {
          console.log(action);
        },
      });
    },
    [
      showModal,
      statusInterview,
      scoreItems,
      id,
      handleCancel,
      returnTotal,
      justification,
    ],
  );

  const openDialogSeeJustification = React.useCallback(() => {
    return showModal({
      actions: [],
      alignActions: 'left',
      size: 'small',
      title: `${'Visualizar justificativa'}`,
      dismissibleIconColor: BaSeTheme.colors.defaultColors.black,
      dismissibleIconType: 'tertiary',
      content: ({ closeModal, emitEvent }) => (
        <BaSeGrid>
          <BaSeGridItem size={12}>
            <BaSeSmall1>Justificativa:</BaSeSmall1>
          </BaSeGridItem>

          <BaSeGridItem size={12}>
            <BaSeParagraph>{justification}</BaSeParagraph>
          </BaSeGridItem>
          <BaSeGridItem size={12}>
            <BaSeButton
              value="Fechar"
              type="primary"
              color={BaSeTheme.colors.institucionais.cinzaSebrae10}
              onClick={() => {
                closeModal('close');
              }}
            />
          </BaSeGridItem>
        </BaSeGrid>
      ),
      onChooseAction: (action) => {
        console.log(action);
      },
    });
  }, [showModal, justification]);

  React.useEffect(() => {
    if (interview) {
      setId(interview.id);
      setStatusInterview(interview.statusInterview);
      if (interview.statusInterview === 'AGUARDANDO_AVALIACAO') {
        setStatus(interview.statusInterview);
      }
    }
  }, [interview]);

  const isValid = scoreItems.some((e) => e.scoreManualEvaluation === '');
  const tabs = React.useMemo(
    () => [
      {
        title: 'Notas do candidato',
        content: () => (
          <ContainerNotes>
            <BaSeParagraph
              fontFamily="Lato"
              color={BaSeTheme.colors.institucionais.cinzaSebrae10}
              isBold
            >
              PONTUAÇÃO DAS CCEs
            </BaSeParagraph>
            <Container>
              <Content>
                {scoreItems?.map(
                  (
                    {
                      descProfileItem = '',
                      scoreSpek,
                      scoreEmpretec = '',
                      confidenceIndex,
                      comparativeScore,
                      scoreManualEvaluation,
                    },
                    index,
                  ) => (
                    <ContentRow key={descProfileItem}>
                      <BaSeSmall1
                        color={BaSeTheme.colors.institucionais.cinzaSebrae45}
                        fontFamily="Lato"
                      >
                        {descProfileItem}
                      </BaSeSmall1>

                      <ContentNotes>
                        <BoxNota msg={index === 0 && 'Nota Empretec'}>
                          <BaSeParagraph
                            color={
                              BaSeTheme.colors.institucionais.cinzaSebrae30
                            }
                            fontFamily="Lato"
                          >
                            {scoreSpek === '' ? '' : scoreSpek}
                          </BaSeParagraph>
                        </BoxNota>

                        {notasRespostas.hasConfidence && (
                          <BoxNota msg={index === 0 && 'Taxa de confiança'}>
                            <BaSeParagraph
                              color={
                                BaSeTheme.colors.institucionais.cinzaSebrae30
                              }
                              fontFamily="Lato"
                            >
                              {confidenceIndex}
                            </BaSeParagraph>
                          </BoxNota>
                        )}
                        {notasRespostas.hasComparative && (
                          <BoxNota msg={index === 0 && 'Nota Comparativa'}>
                            <BaSeParagraph
                              color={
                                BaSeTheme.colors.institucionais.cinzaSebrae30
                              }
                              fontFamily="Lato"
                            >
                              {comparativeScore === 0 ? '0' : comparativeScore}
                            </BaSeParagraph>
                          </BoxNota>
                        )}
                        {notasRespostas.hasCalibration && (
                          <BoxNota msg={index === 0 && 'Nota IA'}>
                            <BaSeParagraph
                              color={
                                BaSeTheme.colors.institucionais.cinzaSebrae30
                              }
                              fontFamily="Lato"
                            >
                              {scoreEmpretec}
                            </BaSeParagraph>
                          </BoxNota>
                        )}

                        {notasRespostas.showManualEvaluateColumn && (
                          <BoxNota
                            msg={index === 0 && 'Nota Editada'}
                            withError={
                              saveManualEvaluate && scoreManualEvaluation === ''
                            }
                          >
                            {notasRespostas.disableManualEvaluateColumn ? (
                              <InputDisabled>
                                <BaSeParagraph
                                  color={
                                    BaSeTheme.colors.institucionais
                                      .cinzaSebrae30
                                  }
                                  fontFamily="Lato"
                                >
                                  {scoreManualEvaluation
                                    ? scoreManualEvaluation.toString()
                                    : ''}
                                </BaSeParagraph>
                              </InputDisabled>
                            ) : (
                              <BaSeInput
                                inputMode="decimal"
                                maxLength={2}
                                isDisabled={
                                  notasRespostas.disableManualEvaluateColumn
                                }
                                onChange={(e) => {
                                  const value = e.trim();
                                  const numericValue = Number(value);

                                  if (/\D/.test(value)) return;

                                  if (numericValue === 0) {
                                    handleChangeManualEvaluate(
                                      descProfileItem,
                                      '0',
                                    );
                                  }

                                  if (value === '') {
                                    handleChangeManualEvaluate(
                                      descProfileItem,
                                      '',
                                    );
                                    return;
                                  }

                                  if (
                                    !/^(0|[1-9]\d*)$/.test(value) ||
                                    numericValue > 25
                                  ) {
                                    handleAttention(
                                      'Nota da CCE deve ser de 0 a 25.',
                                    );
                                    return;
                                  }

                                  handleChangeManualEvaluate(
                                    descProfileItem,
                                    numericValue.toString(),
                                  );
                                }}
                                value={
                                  scoreManualEvaluation
                                    ? scoreManualEvaluation.toString()
                                    : ''
                                }
                              />
                            )}
                          </BoxNota>
                        )}
                      </ContentNotes>
                    </ContentRow>
                  ),
                )}
              </Content>
            </Container>
            <ContainerResultnOTES>
              <BaSeParagraph
                color={BaSeTheme.colors.institucionais.cinzaSebrae10}
                fontFamily="Lato"
              >
                Perfil CCE do Participante
              </BaSeParagraph>
              <ContentBlocs>
                <Item>
                  <BaSeParagraph fontFamily="Lato" color="#fff">
                    {notasRespostas.totalScoreProfile === 0
                      ? '0'
                      : notasRespostas.totalScoreProfile}
                  </BaSeParagraph>
                </Item>

                {notasRespostas.hasConfidence && (
                  <Item>
                    <BaSeParagraph fontFamily="Lato" color="#fff">
                      {notasRespostas.profileConfidence}
                    </BaSeParagraph>
                  </Item>
                )}

                {notasRespostas.hasCalibration && (
                  <Item>
                    <BaSeParagraph fontFamily="Lato" color="#fff">
                      {}
                    </BaSeParagraph>
                  </Item>
                )}
                {notasRespostas.hasComparative && (
                  <Item>
                    <BaSeParagraph fontFamily="Lato" color="#fff">
                      {notasRespostas.totalComparativeScore === 0
                        ? '0'
                        : notasRespostas.totalComparativeScore}
                    </BaSeParagraph>
                  </Item>
                )}
                {notasRespostas.showManualEvaluateColumn && (
                  <Item>
                    <BaSeParagraph fontFamily="Lato" color="#fff">
                      {/* {totalEevaluateScore ? totalEevaluateScore : 0} */}
                      {returnTotal()}
                    </BaSeParagraph>
                  </Item>
                )}
              </ContentBlocs>
            </ContainerResultnOTES>

            {notasRespostas.showManualEvaluateColumn && (
              <BoxPendingAvaliationButtons>
                {!notasRespostas.disableManualEvaluateColumn && (
                  <BaSeButton
                    color={
                      moduleSelected?.id === 1
                        ? moduleSelected?.settingsMap?.secondaryColor
                        : moduleSelected?.settingsMap?.primaryColor
                    }
                    value="Cancelar"
                    type="secondary"
                    onClick={() => {
                      setShowNotas((prev) => !prev);
                      setOnTabIndex(0);
                      fetchData({
                        page: 0,
                        sort: { type: 'DESC' },
                      });
                    }}
                  />
                )}
                {!notasRespostas.disableManualEvaluateColumn && (
                  <BaSeButton
                    color={
                      moduleSelected?.id === 1
                        ? moduleSelected?.settingsMap?.secondaryColor
                        : moduleSelected?.settingsMap?.primaryColor
                    }
                    value="Salvar"
                    onClick={() => {
                      const hasValid = scoreItems.every(
                        (item) => item.scoreManualEvaluation !== '',
                      );

                      if (!hasValid) {
                        handleAttention('Campo obrigatório não informado.');
                      }

                      setSaveManualEvaluate(true);
                      if (isValid) {
                        return;
                      }
                      openDialogConfirmEvaluate();
                    }}
                  />
                )}

                {justification && (
                  <BaSeButton
                    color="#0A1729"
                    value="Justificativa"
                    onClick={() => openDialogSeeJustification()}
                  />
                )}
              </BoxPendingAvaliationButtons>
            )}

            {status && (
              <BoxPendingAvaliation>
                <BaSeParagraph>
                  A entrevista desse candidato encontra-se "Aguardando
                  avaliação", você deseja aprovar ou solicitar revisão do
                  candidato?
                </BaSeParagraph>
                <BoxPendingAvaliationButtons>
                  <BaSeButton
                    color={
                      moduleSelected.id === 1
                        ? moduleSelected?.settingsMap?.secondaryColor
                        : moduleSelected?.settingsMap?.primaryColor
                    }
                    value="Solicitar revisão"
                    type="secondary"
                    onClick={() => openDialogRequestAprove()}
                  />
                  <BaSeButton
                    color={
                      moduleSelected.id === 1
                        ? moduleSelected?.settingsMap?.secondaryColor
                        : moduleSelected?.settingsMap?.primaryColor
                    }
                    value="Aprovar"
                    onClick={() => openDialogConfirmAprove()}
                  />
                </BoxPendingAvaliationButtons>
              </BoxPendingAvaliation>
            )}
          </ContainerNotes>
        ),
      },
      {
        title: 'Resposta #1',
        isDisabled: disabledIndex,
        content: () => (
          <AnswersCandidateDetail
            id={id}
            setDisabledIndex={setDisabledIndex}
            idResposta={setAnswers(1)?.id}
            question={`1 - ${setAnswers(1)?.question?.question}`}
            answer={setAnswers(1)?.answer}
            qtdCaractere={wordCounter(setAnswers(1)?.answer)}
            hasComparative={notasRespostas.hasComparative}
            notasRespostas={notasRespostas}
            numberQuestion={1}
          />
        ),
      },
      {
        title: 'Resposta #2',
        isDisabled: disabledIndex,
        content: () => (
          <AnswersCandidateDetail
            setDisabledIndex={setDisabledIndex}
            id={id}
            idResposta={setAnswers(2)?.id}
            question={`2 - ${setAnswers(2)?.question?.question}`}
            answer={setAnswers(2)?.answer}
            qtdCaractere={wordCounter(setAnswers(2)?.answer)}
            hasComparative={notasRespostas.hasComparative}
            notasRespostas={notasRespostas}
            numberQuestion={2}
          />
        ),
      },
      {
        title: 'Resposta #3',
        isDisabled: disabledIndex,

        content: () => (
          <AnswersCandidateDetail
            setDisabledIndex={setDisabledIndex}
            id={id}
            idResposta={setAnswers(3)?.id}
            question={`3 - ${setAnswers(3)?.question?.question}`}
            answer={setAnswers(3)?.answer}
            qtdCaractere={wordCounter(setAnswers(3)?.answer)}
            hasComparative={notasRespostas.hasComparative}
            notasRespostas={notasRespostas}
            numberQuestion={3}
          />
        ),
      },
      {
        title: 'Resposta #4',
        isDisabled: disabledIndex,

        content: () => (
          <AnswersCandidateDetail
            setDisabledIndex={setDisabledIndex}
            id={id}
            idResposta={setAnswers(4)?.id}
            question={`4 - ${setAnswers(4)?.question?.question}`}
            answer={setAnswers(4)?.answer}
            qtdCaractere={wordCounter(setAnswers(4)?.answer)}
            hasComparative={notasRespostas.hasComparative}
            notasRespostas={notasRespostas}
            numberQuestion={4}
          />
        ),
      },
      {
        title: 'Resposta #5',
        content: () => (
          <AnswersCandidateDetail
            setDisabledIndex={setDisabledIndex}
            id={id}
            idResposta={setAnswers(5)?.id}
            question={`5 - ${setAnswers(5)?.question?.question}`}
            answer={setAnswers(5)?.answer}
            qtdCaractere={wordCounter(setAnswers(5)?.answer)}
            hasComparative={notasRespostas.hasComparative}
            notasRespostas={notasRespostas}
            numberQuestion={5}
          />
        ),
      },
    ],
    [
      disabledIndex,
      scoreItems,
      notasRespostas,
      returnTotal,
      moduleSelected,
      status,
      saveManualEvaluate,
      handleAttention,
      setShowNotas,
      fetchData,
      isValid,
      openDialogConfirmEvaluate,
      openDialogSeeJustification,
      openDialogRequestAprove,
      openDialogConfirmAprove,
      id,
      setAnswers,
      justification,
    ],
  );

  function formataCPF(cpf) {
    //retira os caracteres indesejados...
    cpf = cpf.replace(/[^\d]/g, '');

    //realizar a formatação...
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  }

  return (
    <BaSeContainer
      withAutoScroll={codigo === 1 ? false : true}
      style={{
        height: `${codigo === 1 ? '100%' : '80vh'}`,
      }}
    >
      <Wrapper>
        {codigo === 1 ? (
          <BaSeButton
            leftIcon="arrow-circle-left-tonescale"
            type="tertiary"
            value="Voltar"
            onClick={() => {
              setShowNotas((prev) => !prev);
              setOnTabIndex(0);
              fetchData({
                page: 0,
                sort: { type: 'DESC' },
              });
            }}
          />
        ) : (
          <></>
        )}

        <ContainerTitle>
          <ContentTitle>
            <BaSeParagraph isBold>Visualizar notas e respostas</BaSeParagraph>
            <BaSeParagraph isBold>{`${
              notasRespostas.candidateName
            } - ${formataCPF(notasRespostas.candidateCpf)}`}</BaSeParagraph>
          </ContentTitle>
        </ContainerTitle>
        <ContentTabs>
          <BaSeTabs
            activatedTabIndex={onTabIndex}
            onActivatedTabIndex={setOnTabIndex}
            tabs={tabs}
          />
        </ContentTabs>
      </Wrapper>
    </BaSeContainer>
  );
}

export default VisualizarNotasRespostas;
